import { DividerDesignTokens } from '@primeng/themes/types/divider';

export const baseDividerToken: DividerDesignTokens = {
  vertical: {
    margin: '0 0.5rem',
  },
};
